// global set
var apiDomain = globalSettings.apiDomain;
var sitePrefix = globalSettings.sitePrefix;

var addToCartJump = false;
var currencySymbol = 'USD ';

if (sitePrefix !== 'en') {
    currencySymbol = '$';
}
if ($(window).width() <= 800) {
    $('._type-group').each(function() {
        var $firstLoop = $(this).find('._every-pro').eq(0);
        var proName = $(this).find('._every-pro').eq(0).attr('data-name');
        var proVariantId = $(this).find('._every-pro').eq(0).attr('data-id');
        mobileActiveClassic($firstLoop);
        tipInventory($firstLoop);
        boxIntro(proVariantId);
    });
    $('._every-pro').on('click', function() {
        var proName = $(this).attr('data-name');
        var proVariantId = $(this).attr('data-id');
        mobileActiveClassic($(this));
        tipInventory($(this));
        otherTipInventory($(this));
        boxIntro(proVariantId);
    });
    mobileTicwatchClick();
} else {
    // ticwatch group click event
    $('._type-group').each(function() {
        var $firstLoop = $(this).find('._every-pro').eq(0);
        var proName = $(this).find('._every-pro').eq(0).attr('data-name');
        var proId = $firstLoop.attr('data-pro-id');
        var proVariantId = $firstLoop.attr('data-id');
        $firstLoop.find('input[type="radio"]').prop('checked', 'checked');
        if (proId === '9244277575') {
            $('.silicone-black-tips').show();
        }
        setImg($firstLoop);
        boxIntro(proVariantId);
    });
    $('._every-pro').on('click', function() {
        var proName = $(this).attr('data-name');
        var proId = $(this).attr('data-pro-id');
        var proVariantId = $(this).attr('data-id');
        addToCartJump = false;
        $("._add-to-cart-acc").removeClass("active").text("ADD TO CART").attr('data-status', '0');
        if (proId === '9244277575') {
            $('.silicone-black-tips').show();
        } else {
            $('.silicone-black-tips').hide();
        }
        setImg($(this));
        boxIntro(proVariantId);
    });
}

// ticwatch add to cart
$('._add-to-cart').on('click', function() {
    var formId = $(this).attr('data-id');
    var proName = $(this).attr('data-name');
    var dataStatus = $(this).attr('data-status');
    ga('send', 'event', proName + '-buyBtn', 'click');
    if (dataStatus === '0') { // status 0: add to cart only
        if ($(window).width() > 800) {
            var imgtodrag = $(this).parents('.collection-btn').prev('._every-pro').find('img').eq(0);
            addcartAnimate(imgtodrag);
        }
        addCart(formId, $(this), "cart");
    } else { // status 1: go to cart only 
        window.location.href = '/cart';
    }
});
$("._add-to-cart-ticwatch").on("click", function() {
    var formId = $(this).parents('._type-group').find('.watch-con .active').parents("._every-pro").attr('data-id');
    var proName = $(this).parents('._type-group').find('.watch-con .active').parents("._every-pro").attr('data-name');
    var dataStatus = $(this).attr('data-status');
    ga('send', 'event', proName + '-buyBtn', 'click');
    if (dataStatus === '0') {
        if ($(window).width() > 800) {
            var imgtodrag = $(this).parents('._type-group').find('.watch-con .active');
            addcartAnimate(imgtodrag);
        }
        addCart(formId, $(this), "cart");
    } else {
        window.location.href = '/cart';
    }
});

//add cart animate
function addcartAnimate(imgtodrag) {
    var cart = $('.cart-icon');
    if (imgtodrag) {
        var imgclone = imgtodrag.clone().offset({
            top: imgtodrag.offset().top,
            left: imgtodrag.offset().left
        }).css({
            'opacity': '0.5',
            'position': 'absolute',
            'height': '95px',
            'width': '95px',
            'z-index': '100'
        }).appendTo($('body')).animate({
            'top': cart.offset().top + 10,
            'left': cart.offset().left + 10,
            'width': 75,
            'height': 75
        }, 1000, 'easeInOutExpo');
        setTimeout(function() {
            cart.effect('shake', { times: 1 }, 100);
        }, 1500);
        imgclone.animate({
            'width': 0,
            'height': 0
        }, function() {
            $(this).detach();
        });
    }
}

// ticwatch checkout
$('._goto-checkout').on('click', function() {
    var formId = $(this).attr('data-id');
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            "quantity": 1,
            "id": formId
        },
        success: function(data) {
            window.location.href = "/checkout";
        },
        error: function() {
            console.log('error');
        }
    });
});

// accessories add to cart
$('._add-to-cart-acc').on('click', function() {
    var formId = $(this).parents('._type-group').find('input[type="radio"]:checked').attr('data-id');
    var proName = $(this).parents('._type-group').find('input[type="radio"]:checked').parents("._every-pro").attr('data-name');
    var dataStatus = $(this).attr('data-status');
    ga('send', 'event', proName + '-buyBtn', 'click');
    if (dataStatus === '0') {
        if ($(window).width() > 800) {
            var imgtodrag = $(this).parents('._type-group').find('input[type="radio"]:checked').prev(".img-watch");
            addcartAnimate(imgtodrag);
        }
        addCart(formId, $(this), "cart");
    } else {
        window.location.href = '/cart';
    }
});
// accessories checkout
$('._goto-checkout-acc').on('click', function() {
    var formId = $(this).parents('._type-group').find('input[type="radio"]:checked').attr('data-id');
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            "quantity": 1,
            "id": formId
        },
        success: function(data) {
            window.location.href = "/checkout";
        },
        error: function() {
            console.log('error');
        }
    });
});


function addCart(proId, el, flag) {
    var $this = el;
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            "quantity": 1,
            "id": proId
        },
        success: function(data) {
            if (flag === "cart") {
                //$this.addClass('active').text('VIEW CART');
                var $cartEle = $(".custom-header-action .cart-icon a");
                if ($cartEle.find("i").length == 0) {
                    $cartEle.append("<i></i>");
                }
            }
            el.attr('data-status', '1');
            $("#messageToast").show();
            setTimeout(function() {
                $("#messageToast").hide();
            }, 3000);
            window.location.href = '/cart';
        },
        error: function() {
            console.log('error');
        }
    });
}

function setImg(el) {
    var $this = el;
    var proId = $this.attr('data-pro-id'),
        $parent = $this.parents('._type-group'),
        smallImgHtml = '';
    addToCartJump = false;

    $parent.find('._add-to-cart').removeClass('active').attr("data-status", "0");
    $this.find('input[type="radio"]').prop('checked', 'checked');
    $this.find('.img-watch').addClass('active');
    $this.siblings('._every-pro').find('.img-watch').removeClass('active');
    $this.siblings('._every-pro').find('._notice').removeClass('notice-show');
    $.ajax({
        method: "get",
        url: apiDomain + '/api/overseas/products/' + proId + '?country=' + sitePrefix,
        beforeSend: function() {
            $parent.find('._big-img').append('<div class="home-slideshow-loader"></div>');
        },
        success: function(data) {
            data = JSON.parse(data);
            var description = data.product.body_html;
            $parent.find('.pro-desc').html(description);
            if (data.product.variants && data.product.variants.length > 0) {
                var defaultPrice = data.product.variants[0].price;
                var inventoryQuantity = data.product.variants[0].inventory_quantity;
                var variantId = data.product.variants[0].id;
                setDefaultPrice($parent.find('._default-price'), defaultPrice);
                $parent.find('._default-stock').text(inventoryQuantity);
            }
            if (data.product.images.length > 0) {
                var imgsArr = data.product.images,
                    bigImgSrc = imgsArr[0].src;
                $parent.find('._big-img').html('<img src="' + bigImgSrc + '">');
                // 套装不显示小图  by chchzhai
                if (data.product.product_type !== "Tichome Mini Suit"){
                    $('._small-img').css('display','block');
                    $('._tichome-video').css('display','block');
                    for (var i = 0; i < imgsArr.length; i++) {
                        var imgSrc = imgsArr[i].src,
                            firstSrc = getPath(imgSrc),
                            midSrc = getName(imgSrc),
                            lastSrc = getExt(imgSrc),
                            smallImgSrc = firstSrc + midSrc + '_large' + lastSrc;
                        smallImgHtml += '<li><img src="' + smallImgSrc + '"></li>';
                    }
                    $parent.find('._small-img').html(smallImgHtml);
                    $parent.find('._small-img').find('li').eq(0).addClass('high');
                    smallImgEvent();
                    $('.coupon-desc-copy').show();
                }else{
                    $('._small-img').css('display','none');
                    $('._tichome-video').css('display','none');
                    $('.coupon-desc-copy').hide();
                }
            }
            // 根据库存数量, 显示文案(缺货) by chchzhai
            if (data.product.variants[0].inventory_quantity <= 0) {
                $this.parent().siblings('.tip-accessories').show();
            } else {
                $this.parent().siblings('.tip-accessories').hide();
            }
        },
        complete: function() {
            $('.home-slideshow-loader').remove();
        },
        error: function() {
            console.log('error');
        }
    });
}

function smallImgEvent() {
    $('._small-img').find('li').each(function(index) {
        $(this).on('click', function() {
            var $parent = $(this).parents('._tic-run-left'),
                bigSrc = $(this).find('img').attr('src');
            $(this).addClass('high').siblings('li').removeClass('high');
            $parent.find('._big-img').html('<img src="' + bigSrc + '">');
        });
    });
}

function getName(src) {
    var startstr = src.lastIndexOf('/') + 1;
    var endstr = src.lastIndexOf('.');
    var namestr = src.substring(startstr, endstr);
    return namestr;
}

function getPath(src) {
    var startstr = src.lastIndexOf('/') + 1;
    var path = src.substring(0, startstr);
    return path;
}

function getExt(src) {
    var endstr = src.lastIndexOf('.');
    var ext = src.substring(endstr);
    return ext;
}


/* mobile checkout render */
$("._goto-strap-checkout").on("click", function() {
    $(".blackBg").show();
    $(".checkout-wrapper").slideDown(500);
});
$(".checkout-window-close").on("click", function() {
    $(".blackBg").hide();
    $(".checkout-wrapper").slideUp(500);
});

function mobileCheckoutRender(proType) {
    $(".checkout-available .checkout-choice").each(function() {
        var type = $(this).attr("data-type");
        if (proType == type) {
            $(this).addClass("active").siblings(".checkout-choice").removeClass("active");
            $(this).find("li").eq(0).addClass("active").siblings("li").removeClass("active");
            mobileCheckoutData($(this).find("li").eq(0));
            $(this).find("li").each(function() {
                $(this).on("click", function() {
                    $(this).addClass("active").siblings("li").removeClass("active");
                    mobileCheckoutData($(this));
                });
            });
        }
    });
}

function mobileCheckoutData(el) {
    var $this = el;
    var proId = $this.attr('data-pro-id');
    $.ajax({
        method: "get",
        url: apiDomain + '/api/overseas/products/' + proId + '?country=' + sitePrefix,
        beforeSend: function() {
            $('._checkout-image').append('<div class="home-slideshow-loader"></div>');
        },
        success: function(data) {
            data = JSON.parse(data);
            var imgSrc = data.product.image.src,
                proName = data.product.title,
                proPrice = data.product.variants[0].price,
                variantId = data.product.variants[0].id;
            $("._checkout-name").text(proName);
            $("._checkout-image").html('<img src="' + imgSrc + '"/>');
            $("._checkout-price").text(proPrice);
            $("._goto-checkout").attr("data-id", variantId);
        },
        complete: function() {
            $('.home-slideshow-loader').remove();
        },
        error: function() {
            console.log('error');
        }
    });

}

/* mobile all product render */
function mobileTicwatchClick() {
    $(".watch-small-list li").eq(0).addClass("active").siblings("li").removeClass("active");
    $(".watch-small-list li").each(function(index) {
        if ($(this).hasClass("active")) {
            var proType = $(this).attr("data-type");
            $("._goto-other-checkout").show();
            $("._goto-strap-checkout").hide();
            mobileTicwatchRender($(this));
            strapLoad(proType);
            if (proType === "Silicone" || proType === "Cortical") {
                $("._goto-strap-checkout").show();
                $("._goto-other-checkout").hide();
                mobileCheckoutRender(proType);
            }
        }
        $(this).on("click", function() {
            var proType = $(this).attr("data-type");
            var leftValue = $(this).width() * index;
            addToCartJump = false;
            $('._add-to-cart').removeClass('active').text('ADD TO CART').attr("data-status", "0");
            $(this).addClass("active").siblings("li").removeClass("active");
            $(".bottom-line").animate({ left: leftValue + "px" }, 500);
            $("._goto-other-checkout").show();
            $("._goto-strap-checkout").hide();
            mobileTicwatchRender($(this));
            strapLoad(proType);
            if (proType === "Silicone" || proType === "Cortical") {
                $("._goto-strap-checkout").show();
                $("._goto-other-checkout").hide();
                mobileCheckoutRender(proType);
            }
        });
    });
}

function strapLoad(proType) {
    if (proType === "Silicone" || proType === "Cortical") {
        $(".accessories-detail .strap-list").each(function() {
            var type = $(this).attr("data-type");
            if (proType == type) {
                $(this).addClass("active").siblings(".strap-list").removeClass("active");
                $(this).find("li").eq(0).addClass("active").siblings("li").removeClass("active");
                $(this).find("li").each(function() {
                    $(this).on("click", function() {
                        addToCartJump = false;
                        $('._add-to-cart').removeClass('active').text('ADD TO CART').attr("data-status", "0");
                        $(this).addClass("active").siblings("li").removeClass("active");
                        mobileTicwatchRender($(this));
                    });
                });
            }
        });
    } else {
        $(".accessories-detail .strap-list").removeClass("active");
    }
}

function mobileTicwatchRender(el) {
    var $this = el;
    var proId = $this.attr('data-pro-id'),
        $parent = '',
        imgHtml = '',
        strapHtml = '';
    if ($this.parents(".top-wrapper").length != 0) {
        $parent = $this.parents('.top-wrapper').siblings(".content-wrapper");
    }
    if ($this.parents(".content-wrapper").length != 0) {
        $parent = $this.parents(".content-wrapper");
    }
    $.ajax({
        method: "get",
        url: apiDomain + '/api/overseas/products/' + proId + '?country=' + sitePrefix,
        beforeSend: function() {
            $parent.find('._img-render').append('<div class="home-slideshow-loader"></div>');
        },
        success: function(data) {
            data = JSON.parse(data);
            var description = data.product.body_html;

            if (data.product.variants && data.product.variants.length > 0) {
                var defaultPrice = data.product.variants[0].price;
                var defaultTitle = data.product.title;
                var variantId = data.product.variants[0].id;
                var inventoryQuantity = data.product.variants[0].inventory_quantity;

                if (inventoryQuantity <= 0) {
                    $('._add-to-cart').hide();
                    $parent.find('.pro-detail').html(description + '<p class="text-error">Temporarily Out Of Stock.</p>');
                } else {
                    $('._add-to-cart').show();
                    $parent.find('.pro-detail').html(description);
                }

                if (variantId === 32245974983) {
                    $(".volcano-alert").show();
                } else {
                    $(".volcano-alert").hide();
                }

                if (variantId === 32246272199) {
                    $(".charger-alert").show();
                } else {
                    $(".charger-alert").hide();
                }

                if (variantId === 32400616199) {
                    $(".silicone-black-tips").show();
                } else {
                    $(".silicone-black-tips").hide();
                }

                $parent.find('._default-stock').text(inventoryQuantity);
                setDefaultPrice($parent.find('._default-price'), defaultPrice);
                setDefaultPrice($parent.siblings(".bottom-wrapper").find("._default-price"), defaultPrice);
                $parent.find('._default-title').text(defaultTitle);
                $(".checkout-left, .cart-right").attr("data-id", variantId);
                $(".checkout-left, .cart-right").attr("data-name", defaultTitle);
                $(".notify ._wish-list").attr("data-name", defaultTitle);
                if (data.product.product_type === "Unplug & Run." || data.product.product_type === "Smart & Stunning.") {
                    $parent.find('._default-alert').text("Shipping lead time is 7-10 business days. We appreciate your patience.");
                } else {
                    $parent.find('._default-alert').text("");
                }
                $parent.siblings("._watch-mobile-btns").find("._add-to-cart").text("ADD TO CART");
                if (data.product.product_type === "Ticwatch Sport" || data.product.product_type === "Ticwatch Express" || data.product.product_type === "Earphone") {
                    $parent.siblings("._watch-mobile-btns").find("._amazon-btn-box").addClass("amazon-hide");
                } else {
                    $parent.siblings("._watch-mobile-btns").find("._amazon-btn-box").removeClass("amazon-hide");
                }
                getCountry();
            }
            if (data.product.images.length > 0) {
                var imgsArr = data.product.images;
                for (var i = 0; i < imgsArr.length; i++) {
                    var imgSrc = imgsArr[i].src,
                        firstSrc = getPath(imgSrc),
                        midSrc = getName(imgSrc),
                        lastSrc = getExt(imgSrc),
                        smallImgSrc = firstSrc + midSrc + '_large' + lastSrc;
                    imgHtml += '<li class="swiper-slide"><img src="' + smallImgSrc + '"></li>';
                }
                //$parent.find('._img-render').html(imgHtml);
                $parent.find('.slide-show').html(' <div class="swiper-container show-inner"> ' +
                    '<ul class="swiper-wrapper _img-render">' + imgHtml + '</ul>' +
                    '<div class="swiper-pagination"></div>' +
                    '<div class="swiper-button-prev swiper-button-left"></div>' +
                    '<div class="swiper-button-next swiper-button-right"></div>' +
                    '</div>');
            }
            var slideSwiper = new Swiper('.show-inner', {
                loop: true,
                pagination: '.swiper-pagination',
                paginationClickable: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                autoplayDisableOnInteraction: false,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
            });
        },
        complete: function() {
            $('.home-slideshow-loader').remove();
        },
        error: function() {
            console.log('error');
        }
    });
}

/* Ticwatch active and classic render */
function mobileActiveClassic(el) {
    var $this = el;
    var proId = $this.attr('data-pro-id'),
        $parent = '',
        imgHtml = '';
    $parent = $this.parents(".ticwatch-collection");
    $this.find('.img-watch').addClass('active');
    $this.siblings('._every-pro').find('.img-watch').removeClass('active');
    $.ajax({
        method: "get",
        url: apiDomain + '/api/overseas/products/' + proId + '?country=' + sitePrefix,
        beforeSend: function() {
            $parent.find('._img-render').append('<div class="home-slideshow-loader"></div>');
        },
        success: function(data) {
            data = JSON.parse(data);
            var description = data.product.body_html;
            if (data.product.variants && data.product.variants.length > 0) {
                var defaultPrice = data.product.variants[0].price;
                var proName = data.product.title;
                var variantId = data.product.variants[0].id;
                var inventoryQuantity = data.product.variants[0].inventory_quantity;
                setDefaultPrice($parent.find('._default-price'), defaultPrice);
                $parent.find('._watch-name').text(proName);
                $parent.find('._default-stock').text(inventoryQuantity);
                $(".checkout-left, .cart-right").attr("data-id", variantId);
                $(".checkout-left, .cart-right").attr("data-name", proName);

                if (variantId === 50335134535 || variantId === 1766318833694 || variantId === 1795882156062) { //Ticwatch E Ice shipping date modify
                    $("._ticwatch-preorder-tips").text("*All shipments will be processed by November 30th, 2017");
                } else {
                    $("._ticwatch-preorder-tips").text("*All shipments will be processed by November 26th, 2017");
                }
            }
            if (data.product.product_type === "Tichome Mini Suit") {
                $('.coupon-desc-copy').hide();
            } else {
                $('.coupon-desc-copy').show();
            }
            if (data.product.images.length > 0) {
                var imgsArr = data.product.images;
                for (var i = 0; i < imgsArr.length; i++) {
                    var imgSrc = imgsArr[i].src,
                        firstSrc = getPath(imgSrc),
                        midSrc = getName(imgSrc),
                        lastSrc = getExt(imgSrc),
                        smallImgSrc = firstSrc + midSrc + '_large' + lastSrc;
                    if (i == 0) {
                        if (data.product.product_type === "Unplug & Run.") {
                            imgHtml += '<li class="swiper-slide"><img src="' + smallImgSrc + '"><span video-url="https://www.youtube.com/embed/p1ZlCBRMDIM" class="mobile-ticwatch-play _mobile-ticwatch-play"></span></li>';
                        } else if (data.product.product_type === "Smart & Stunning.") {
                            imgHtml += '<li class="swiper-slide"><img src="' + smallImgSrc + '"><span video-url="https://www.youtube.com/embed/Ax7QKR3DiM4" class="mobile-ticwatch-play _mobile-ticwatch-play"></span></li>';
                        } else if (data.product.product_type == "Tichome Mini"){
                            imgHtml += '<li class="swiper-slide"><img src="' + smallImgSrc + '"><span video-url="https://www.youtube.com/embed/QKC3rKhHAPE" class="mobile-ticwatch-play _mobile-ticwatch-play"></span></li>';
                        } else {
                            imgHtml += '<li class="swiper-slide"><img src="' + smallImgSrc + '"></li>';
                        }
                    } else {
                        imgHtml += '<li class="swiper-slide"><img src="' + smallImgSrc + '"></li>';
                    }
                }
                //$parent.find('._img-render').html(imgHtml);
                $parent.find('.slide-show').html(' <div class="swiper-container show-inner"> ' +
                    '<ul class="swiper-wrapper _img-render">' + imgHtml + '</ul>' +
                    '<div class="swiper-pagination"></div>' +
                    '<div class="swiper-button-prev swiper-button-left"></div>' +
                    '<div class="swiper-button-next swiper-button-right"></div>' +
                    '</div>');
            }
            var slideSwiper = new Swiper('.show-inner', {
                loop: true,
                pagination: '.swiper-pagination',
                paginationClickable: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                autoplayDisableOnInteraction: false,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
            });
            var videoLayoutEl = '._video-layout';
            var videoBoxEl = '._video-box';
            var videoEl = $(videoBoxEl).find('iframe').get(0);
            $("._mobile-ticwatch-play").on("click", function(e) {
                e.preventDefault();
                var videoUrl = $(this).attr('video-url');
                $(videoEl).attr('src', videoUrl);
                $(videoLayoutEl + ',' + videoBoxEl).show();
            });
        },
        complete: function() {
            $('.home-slideshow-loader').remove();
        },
        error: function() {
            console.log('error');
        }
    });
}



/*collection all scroll*/
if ($('#tab-all').length > 0) {
    var allW = 0,
        lis = $('#tab-all ul li');
    lis.each(function(i, v) {
        allW += parseInt($(v).width());
    });
    $('#tab-all .watch-small-list').width(allW);
    var tabscroll = new IScroll('#tab-all', {
        scrollX: true,
        scrollY: false,
        scrollbars: false,
        preventDefault: false,
        hScrollbar: false,
        preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|A)$/ }
    });

    $("#tab-all ul li").each(function(index) {
        if (index == 0) {
            $(this).find(".line-bottom").addClass("active");
        }
        $(this).on("click", function() {
            if ($(this).hasClass("active")) {
                $(this).find(".line-bottom").addClass("active");
                $(this).siblings("li").find(".line-bottom").removeClass("active");
            }
        });
    });
}

/* ticwatch difference */
if ($(".pro-difference-window").length > 0) {
    $("._pro-difference").on("click", function() {
        $(".pro-difference-window").css("display", "table");
    });
    $("._se-preOrder").on("click", function() {
        $(".pro-difference-window").css("display", "table");
        $(".se-preorder-content").addClass("active").siblings(".window-content").removeClass("active");
    });
    $("._se-policy").on("click", function() {
        $(".pro-difference-window").css("display", "table");
        $(".se-policy-content").addClass("active").siblings(".window-content").removeClass("active");
    });
    $("._difference-close-btn").on("click", function() {
        $(".pro-difference-window").css("display", "none");
    });
}

if ($(".coupon-copy-btn").length > 0) {
    $(".coupon-copy-btn").on("click", function(){
        $("#couponCode").select();
        document.execCommand('Copy');
        alert('Copy successfully');
    });
}

/* box introduce */
function boxIntro(variantId) {
    if ($(".box-intro").length > 0) {
        var requestUrl = $("._box-url").attr("data-url");
        $.ajax({
            type: 'get',
            url: requestUrl,
            dataType: 'text',
            success: function(data) {
                var result = $.parseJSON(data);
                var productList = result.product_inbox;
                for (var index = 0; index < productList.length; index++) {
                    var productIdArr = productList[index].productId;
                    var productImgArr = productList[index].boxImage;
                    var productContent = productList[index].boxContent;
                    if (productIdArr.indexOf(variantId) > -1) {
                        var imgHtml = "";
                        var contentHtml = "";
                        for (var imgIndex = 0; imgIndex < productImgArr.length; imgIndex++) {
                            imgHtml += "<li><img src='" + productImgArr[imgIndex] +"'/></li>";
                        }
                        for (var conIndex = 0; conIndex < productContent.length; conIndex++) {
                            contentHtml += "<li>" + productContent[conIndex] + "</li>";
                        }
                        if (variantId === "32360897351" || variantId === "1766319161374" || variantId === "1795882188830") {
                            $("._box-img, ._box-text").addClass("box-steel");
                        } else {
                            $("._box-img, ._box-text").removeClass("box-steel");
                        }
                        $("._box-img").html(imgHtml);
                        $("._box-text").html(contentHtml);
                    }
                }
            },
            error: function() {
                console.log("error")
            }
        });
    }
}

/* more content slide */
function moreContent() {
    if ((".more-section").length > 0) {
        $(".more-section .more-btn").on("click", function() {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(".more-section .detail-guide").slideUp(1000);
            } else {
                $(this).addClass("active");
                $(".more-section .detail-guide").slideDown(1000);
                var scrollTopValue = $(".more-section .detail-guide").offset().top - 60;
                $("html,body").stop(true);
                $("html,body").animate({ scrollTop: scrollTopValue });
            }
        });
    }
}
moreContent();

/* ticwatch tab event */
function ticwatchTab() {
    var videoLayoutEl = '._video-layout';
    var videoBoxEl = '._video-box';
    var videoEl = $(videoBoxEl).find('iframe').get(0);
    $('._tab-tit').find('li').each(function (index) {
        var $this = $(this);
        $this.on('click', function () {
            var offsetTop = $('._tab-part').eq(index).offset().top;
            $this.addClass('active').siblings('li').removeClass('active');
            $('._tab-part').eq(index).show().siblings('._tab-part').hide();
        });
    });
    $(".comment-section li").each( function(index) {
        $(this).find(".comment-more").on("click", function() {
            if($(this).hasClass("active")) {
                $(this).html("more &gt;&gt;").siblings(".comment-content").removeClass("more");
                $(this).removeClass("active");
            } else {
                $(this).html("close &gt;&gt;").addClass("active");
                $(this).siblings(".comment-content").addClass("more");
            }
        });
    });
    $("._review-video li").each(function(){
        $(this).on("click",function(e){
            e.preventDefault();
            var videoUrl = $(this).attr('video-url');
            $(videoEl).attr('src', videoUrl);
            $(videoLayoutEl + ',' + videoBoxEl).show();
        });
    });
    $(".tab-reviews .review-tab li").each(function(index) {
        $(this).on("click", function() {
            $(this).addClass("active").siblings("li").removeClass("active");
            $(".tab-reviews .review-content .review-content-list").eq(index).addClass("active").siblings(".review-content-list").removeClass("active");
        });
    });
    if ($(window).width() <= 800 && window.location.href.indexOf('/collections/ticwatch') > -1) {
        $(".tab-wrapper").attr("id","tabTop");
        $(window).scroll(function(){
            if ($(window).scrollTop() >= $(".tab-wrapper").offset().top) {
                $("._tab-tit").addClass("fixed-tit");
            } else {
                $("._tab-tit").removeClass("fixed-tit");
            }
        });
    }
}
ticwatchTab();

/* user comment */
function userComment() {
    if ($(".tab-reviews").length > 0) {
        $(".tab-reviews .review-content-user li").each(function() {
            var $commentEle = $(this).find(".user-comment");
            var $commentMore = $(this).find(".user-comment-more");
            var text = $commentEle.text();
            var maxLength = 100;
            if (text.length > maxLength) {
                $commentEle.html(text.substring(0,maxLength)+'...');
                $commentMore.css("display", "inline-block");
            }
            $commentMore.on("click", function() {
                if ($(this).hasClass("active")) {
                    $commentEle.html(text.substring(0,maxLength)+'...');
                    $(this).removeClass("active");
                } else {
                    $commentEle.html(text);
                    $(this).addClass("active");
                }
            });
        });
    }
}
userComment();

// default price
function setDefaultPrice(el, totalPrice) {
    var self = this;
    el.html("<span class='money' data-currency-usd=$"+ totalPrice +">" + currencySymbol + totalPrice + '</span>');
    console.log(sitePrefix)
    if (sitePrefix !== 'en') {
        currencyFormat();
    }
}
function currencyFormat() {
    /* Cookie currency */
    var cookieCurrency = Currency.cookie.read();
    // If there's no cookie.
    if (cookieCurrency == null) {
      if (shopCurrency !== defaultCurrency) {
        Currency.convertAll(shopCurrency, defaultCurrency);
      }
      else {
        Currency.currentCurrency = defaultCurrency;
      }
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if (jQuery('[name=currencies]').size() && jQuery('[name=currencies] option[value=' + cookieCurrency + ']').size() === 0) {
      Currency.currentCurrency = shopCurrency;
      Currency.cookie.write(shopCurrency);
    }
    else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency;
    }
    else {
      Currency.convertAll(shopCurrency, cookieCurrency);
    }
}

/*amazon button*/
function getCountry(){
  var country = '';
  $.ajax({
    url: '//freegeoip.net/json/',
    type: 'POST',
    dataType: 'jsonp',
    success: function(location) {
        switch ( location.country_code ) {
            case 'US':
                country = 'US';
                amazonBtnState();
                break;
            /* case 'GB':
                country = 'GB';
                amazonBtnStateEu('https://www.amazon.co.uk/dp/B077NSBVFN');
                break;
            case 'DE':
                country = 'DE';
                amazonBtnStateEu('https://www.amazon.de/dp/B077NSBVFN');
                break;
            case 'FR':
                country = 'FR';
                amazonBtnStateEu('https://www.amazon.fr/dp/B077NSBVFN');
                break;
            case 'IT':
                country = 'IT';
                amazonBtnStateEu('https://www.amazon.it/dp/B077NSBVFN');
                break;
            case 'ES':
                country = 'ES';
                amazonBtnStateEu('https://www.amazon.es/dp/B077NSBVFN');
                break; */
            default: 
                break;
        }
    }
  });
}
function amazonBtnState(type, proId) {
  var watchBtnBoxM = '._watch-mobile-btns ._amazon-btn-box';
  var amazonBtn = '._amazon-btn-box.pc';
  var isShow = $(watchBtnBoxM).length > 0 || $(amazonBtn).length > 0;
  var hasHideClass = $(watchBtnBoxM).hasClass('amazon-hide');
  if (isShow && !hasHideClass) {
    $('.store-collection .collection-btn a').addClass('has-amazon');
    $('._amazon-btn-box').addClass('show');
    $('._watch-mobile-btns').find('._add-to-cart').addClass('cart-columns');
    $(".bottom-price").hide();
  } else {
    $('.store-collection .collection-btn a').removeClass('has-amazon');
    $('._amazon-btn-box').removeClass('show');
    $('._watch-mobile-btns').find('._add-to-cart').removeClass('cart-columns');
    $(".bottom-price").show();
  }
}
function amazonBtnStateEu(url) {
    var amazonBtnEu = '._amazon-btn-box.amazon-eu-site .amazon-btn-eu',
        amazonBtnEuBoxPc = '._amazom-btn-eu',
        amazonBtnEuBoxM = '._amazom-btn-eu-m';
    var screenWidth = $(window).width();

    $(amazonBtnEu).attr('href', url);
    if( screenWidth > 800 ) {
        $(amazonBtnEuBoxPc).addClass('active');
        $(amazonBtnEuBoxM).removeClass('active');
    } else {
        $(amazonBtnEuBoxPc).removeClass('active');
        $(amazonBtnEuBoxM).addClass('active');
        $(".bottom-price").hide();
        $('._watch-mobile-btns').find('._add-to-cart').addClass('cart-columns');
    }
}

window.onload = function() {
    getCountry();
};

// tichome 购买页移动端
var tichomeMobile = {
    screenWidth: $(window).width(),
    init: function (){
        //this.tichomeSwiper();
        this.showProBuy();
        this.cancleShowPro();
        this.selectPro();
    },
    tichomeSwiper: function (){
        var self = this;
        if(self.screenWidth < 800){
            var tichomeSwiper = new Swiper('.tichome-container', {
                loop : false,
                freeMode : true,
                freeModeMomentum: false,
                slidesPerView : 2.5,
                spaceBetween : 10
            });
        }
    },
    showProBuy: function(){
        var self = this;
        $('._show-pro').on( 'click', function (){
            $('.tichome-pro-shell').css('display', 'block');
            $('._tichome-select-frame').css('display', 'block');
            self.tichomeSwiper();
        })
    },
    cancleShowPro: function (){
        var self = this;
        $('.tichome-pro-shell').on('click', function (){
            $('.tichome-pro-shell').css('display', 'none');
            $('._tichome-select-frame').css('display', 'none');
            self.setPro();
        });
    },
    selectPro: function (){
        var self = this;
        $('._selected').on('click', function (){
            $('.tichome-pro-shell').css('display', 'none');
            $('._tichome-select-frame').css('display', 'none');
            self.setPro();
        })
    },
    setPro: function(){
        var proName = $('.img-watch.tichome-img-watch.active >.tichome-pro-inf span:eq(0)').text()
        proImgSrc = $('.img-watch.tichome-img-watch.active > img').attr('src');
        $('._show-pro >img').attr('src', proImgSrc);
        $('._show-pro .tichomemini-title-inventory span:eq(1)').text(proName);
    }
}
tichomeMobile.init();
// 库存提示文案添加 by chchzhai
// 所有商品库存提示，初始化函数，移动端   
function tipInventory(el) {
    var $this = el;
    var proId = $this.attr('data-pro-id');
    $.ajax({
        method: "get",
        url: apiDomain + '/api/overseas/products/' + proId + '?country=' + sitePrefix,
        success: function(data) {
            data = JSON.parse(data);
            if (data.product.variants[0].inventory_quantity <= 0){
                $this.parent().siblings('.tip-accessories').show();
            } else {
                $this.parent().siblings('.tip-accessories').hide();
            }
        },
        error: function() {
            console.log('error');
        }
    });
}
// tichomemini购买页其余商品库存提示, 移动端 (tichomemini购买页和其余商品的购买页点击商品传递的el参数不同)
function otherTipInventory(el) {
    var $this = el.parents('.tichomemini-pro-choose._tichome-select-frame').siblings('.tic-run-right').find('.tip-tichomemini');
    var proId = el.attr('data-pro-id');
    $.ajax({
        method: "get",
        url: apiDomain + '/api/overseas/products/' + proId + '?country=' + sitePrefix,
        success: function(data) {
            data = JSON.parse(data);
            if (data.product.variants[0].inventory_quantity <= 0){
                $this.show();
            } else {
                $this.hide();
            }
        },
        error: function() {
            console.log('error');
        }
    });
}

